module.exports = __webpack_public_path__ + "img/spe3.d29da755.png";